import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-scoring',
  templateUrl: './scoring.component.html',
  styleUrls: ['./scoring.component.css']
})
export class ScoringComponent implements OnInit {
  @Output() onPoints = new EventEmitter<number>();  

  numbOfCalcs: number = 10;
  attemptCount: number = 0;
  correctCount: number = 0;
  timebonus: number;
  timeStart;
  timeEnd;
  timeSpent: number;

  constructor() { }

  ngOnInit() {
    this.reset();
  }

  setNumberOfAttempts(val: number)
  {
    this.numbOfCalcs = val;
  }

  done() : boolean {
    return (this.numbOfCalcs === this.attemptCount);
  }

  reset(){
    this.attemptCount = 0;
    this.correctCount = 0;
    this.timeSpent = 0;
  }

  startTime(){
    this.timeStart = new Date();  
  }

  wrong(){
    this.endTime();
    this.attemptCount++;
  }

  correct(){
    this.endTime();
    this.correctCount++;
    this.attemptCount++;
  }

  endTime()
  {
    this.timeEnd = new Date();
    this.timeSpent += (this.timeEnd.getTime() - this.timeStart.getTime());
  }

  setTimeBonus(val: number){
    this.timebonus = val;
  }

  givePoints() : number {
//    alert('correctCount '+this.correctCount + ', this.attemptCount');

    var points = Math.floor ((100 * this.correctCount / this.attemptCount) / ((this.timeSpent / this.attemptCount) * this.timebonus));
    this.onPoints.emit(points);
    return points;
  }


}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/scoring/scoring.component.ts